module.exports = __webpack_public_path__ + "static/media/kv-all-premium.c52efd91.jpeg";